<template>
    <a :href="landingUrl" class="auth-landing-logo" :aria-label="$t('auth_landing.link')">
        <img
            src="@/assets/icons/echat-logo-text.svg"
            alt="E-chat"
            class="auth-landing-logo__image"
        />
    </a>
</template>

<script setup>
import { useLandingUrl } from "@/composables/useLandingUrl.js";

const { landingUrl } = useLandingUrl();
</script>

<style lang="scss" scoped>
.auth-landing-logo {
    position: absolute;
    top: 40px;
    left: 7vw;
    z-index: 1;

    display: block;

    &__image {
        display: block;
        width: 96px;
        height: auto;
    }
}

// below 1200px the auth layout is a single column: a smaller logo pinned to the top-left corner.
// It stays out of the flow so the page keeps its original vertical centering.
@media screen and (max-width: 1200px) {
    .auth-landing-logo {
        top: 16px;
        left: 16px;

        &__image {
            width: 48px;
        }
    }
}
</style>
